import BaseTableReport from 'components/atoms/base-table/report/report';
import { useTranslation } from 'react-i18next';

import { useColumns } from './useColumns';

import type {
  BillingClaimsAthena,
  Filters,
} from 'infrastructure/hooks/billingClaimsAthena/types';
import type { FC } from 'react';

interface Props {
  data: BillingClaimsAthena[] | undefined;
  count: number | undefined;
  filters: Filters;
  isLoading: boolean;
  changePage: (page: number) => void;
}

const BillingClaimsAthenaTable: FC<Props> = ({
  data,
  count,
  filters,
  isLoading,
  changePage,
}) => {
  const columns = useColumns();
  const { t } = useTranslation();

  return (
    <div>
      <BaseTableReport
        isLoading={isLoading}
        columns={columns}
        headerTitle={t('labels.athenaClaims')}
        dataSource={data}
        pagination={{
          current: filters.page,
          pageSize: filters.items,
          total: count,
          onChange: changePage,
        }}
        showCount
        anchor
      />
    </div>
  );
};

export default BillingClaimsAthenaTable;
